import { FC } from 'react'
import { MenuItem, MenuItemProps } from '@mui/material'

const MenuItemWrapper: FC<MenuItemProps> = ({ ...props }) => (
  <MenuItem {...props} />
)

export default MenuItemWrapper
